import { Lock, Users } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Checkbox } from "@/components/ui/checkbox";

export const CreateVisibility = ({ value, onChange, users = [], title = "Visibilità", testid = "create-visibility" }) => {
  const { user } = useAuth();
  const active = users.filter((u) => u.is_active !== false);
  const membri = value.membri || [];
  const toggle = (id, on) => onChange({ ...value, membri: on ? [...membri, id] : membri.filter((m) => m !== id) });
  return (
    <div className="rounded-2xl border border-[#5FB3EA] bg-white/60 p-4 space-y-3" data-testid={testid}>
      <div className="text-xs font-bold uppercase tracking-[0.16em] text-[#E8173A] flex items-center gap-1.5"><Lock className="h-3.5 w-3.5" />{title}</div>
      <div className="flex flex-wrap gap-2">
        {[["tutti", "Tutti i soci", Users], ["riservato", "Riservato", Lock]].map(([v, l, Icon]) => (
          <button key={v} type="button" onClick={() => onChange({ ...value, visibilita: v })} aria-pressed={value.visibilita === v} data-testid={`${testid}-${v}`}
            className={`min-h-[40px] inline-flex items-center gap-1.5 rounded-full px-4 text-sm font-bold border transition-colors ${value.visibilita === v ? "bg-[#0A1128] text-white border-[#0A1128]" : "bg-white text-[#0A1128] border-[#5FB3EA]"}`}>
            <Icon className="h-4 w-4" />{l}
          </button>
        ))}
      </div>
      {value.visibilita === "riservato" && (
        <div className="grid gap-1.5 sm:grid-cols-2" data-testid={`${testid}-members`}>
          {active.map((u) => {
            const forced = u.id === user?.id || u.role === "admin";
            return (
              <label key={u.id} className="flex items-center gap-2 text-sm font-semibold text-[#0A1128] min-h-[36px]">
                <Checkbox checked={forced || membri.includes(u.id)} disabled={forced} onCheckedChange={(on) => toggle(u.id, on)} data-testid={`${testid}-member-${u.id}`} />
                {u.nome} {u.cognome}
                {u.id === user?.id ? <span className="text-xs text-slate-500">(tu)</span> : u.role === "admin" && <span className="text-xs text-slate-500">(amministratore)</span>}
              </label>
            );
          })}
          <p className="sm:col-span-2 text-[11px] text-slate-600">Tu e l'amministratore avete sempre accesso. Dopo la creazione, solo l'amministratore può modificare la visibilità.</p>
        </div>
      )}
    </div>
  );
};
